import { render, staticRenderFns } from "./MultiSelectbox.vue?vue&type=template&id=3c55ac8a&"
import script from "./MultiSelectbox.vue?vue&type=script&lang=js&"
export * from "./MultiSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports